import { defineStore } from "pinia";
import http from "@/composables/axios";

export const useWidgetStore = defineStore('widget', {
    state: () => ({
        token: localStorage.getItem('widgetToken') || null,
        expiry: Number(localStorage.getItem('widgetTokenExpiry') || 0),
        refresh: localStorage.getItem('widgetTokenRefresh') || null,
    }),

    actions: {
        async getValidWidgetToken() {
            const now = Math.floor(Date.now() / 1000)
            const expiry = Number(localStorage.getItem('widgetTokenExpiry') || 0)
            const token = localStorage.getItem('widgetToken')
            const refreshToken = localStorage.getItem('widgetTokenRefresh')

            // if dont have token
            if (!token || !expiry) {
                await this.getWidgetAuth();
                return localStorage.getItem('widgetToken');
            }

            // if token has expired
            if (now >= expiry - 3600) {
                if (refreshToken) {
                    await this.refreshWidgetAuth();
                    return localStorage.getItem('widgetToken');
                } else {
                    await this.getWidgetAuth();
                    return localStorage.getItem('widgetToken');
                }
            }

            //  Token is valid
            return Promise.resolve(token)
        },

        async getWidgetAuth() {
            try {
                const res = await http.get('07/vca');
                if (res.status === 200 && res.data?.access_token) {
                    const now = Math.floor(Date.now() / 1000);
                    const expiresAt = now + Number(res.data.expires_in);

                    localStorage.setItem('widgetToken', res.data.access_token);
                    localStorage.setItem('widgetTokenExpiry', String(expiresAt));
                    localStorage.setItem('widgetTokenRefresh', res.data.refresh_token);

                    this.token = res.data.access_token;
                    this.expiry = expiresAt;
                    this.refresh = res.data.refresh_token;
                }
            } catch (err) {
                console.error('getWidgetAuth error', err);
            }
        },

        refreshWidgetAuth() {
            return http.put('07/vca/refresh', {
                token: localStorage.getItem('widgetTokenRefresh')
            })
            .then(res => {
                if (res.status === 200 && res.data?.access_token) {
                    const now = Math.floor(Date.now() / 1000)
                    const expiresAt = now + Number(res.data.expires_in)

                    localStorage.setItem('widgetToken', res.data.access_token)
                    localStorage.setItem('widgetTokenExpiry', String(expiresAt))
                    localStorage.setItem('widgetTokenRefresh', res.data.refresh_token)

                    this.token = res.data.access_token
                    this.expiry = expiresAt
                    this.refresh = res.data.refresh_token
                } else {
                    return this.getWidgetAuth()
                }
            })
            .catch(err => {
                console.error('refreshWidgetAuth error', err)
                return this.getWidgetAuth()
            })
        }
    }
})
